module.exports = __webpack_public_path__ + "static/media/custom_clearance_bg.30079109.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/freight_forwarding/custom_clearance_bg.jpg
// module id = 155
// module chunks = 0 3